import { render } from "./SurveySummary.vue?vue&type=template&id=71007bc5&scoped=true"
import script from "./SurveySummary.vue?vue&type=script&lang=js"
export * from "./SurveySummary.vue?vue&type=script&lang=js"

import "./SurveySummary.vue?vue&type=style&index=0&id=71007bc5&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71007bc5"]])

export default __exports__